import { useQuery } from "@tanstack/react-query"
import { VyneUserTypes } from "@vynedental/design-system"
import GlobalState from "trellis:state/globalState"
import api from "trellis:utilities/api"

export const useCheckTinHold = (isPmg: boolean) => {
  const userName = GlobalState.UserInfo.userName.peek()
  const userType = GlobalState.UserType.peek()

  return useQuery({
    queryKey: ['tinHold'],
    queryFn: async () => {
      const response = await api.checkTinHold({
        Username: userName
      })
      return response.data as string[]
    },
    enabled: userType === VyneUserTypes.remoteLite && !isPmg
  })
}